export default __webpack_public_path__ + "static/media/trash-icon-dark-lg.6f0264dd.svg";